import {Injectable} from '@angular/core';
import {ConstantsService} from '@app/services/constants/constants.service';

@Injectable({
    providedIn: 'root'
})
export class BridgeService {

    constructor(
        private constants: ConstantsService
    ) {
    }

    sendDataViaBridge(data) {
        window.parent.postMessage(data, '*');
    }

    performData: any = (event: any) => {
        let data = event.data;
        Object.keys(data).forEach(key => {
            switch (key) {
                case 'creator_id':
                    this.constants.setCreator(data[key]);
                    break;
                default:
                
            }
        });
    }

}
